
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-14626.92 16987.35 12.521 13.301"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Group_8362","data-name":"Group 8362","transform":"translate(-16042.27 16411)","opacity":".64"}},[_c('path',{staticClass:"cls-2",attrs:{"id":"Path_3678","d":"M2 30.5v3.117h11.221V30.5","data-name":"Path 3678","transform":"translate(1414 555.383)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Path_3679","d":"M19.931 2l-.031 8.727 4.239-4.052","data-name":"Path 3679","transform":"translate(1401.679 575)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Line_1863","d":"M4.177 4.052L0 0","data-name":"Line 1863","transform":"translate(1417.403 581.675)"}})])])
          )
        }
      }
    